<template>
  <Login />
</template>

<script>
import Login from '@/components/LogIn.vue'

export default {
  name: 'Acceso',
  components: { Login },
}
</script>
